import axios from 'axios';
import { ApiError, ERROR_TYPES } from './errorTypes';
import { authBaseUrl } from './auth';
import { getLoginRateLimitMessage } from './loginMessages';

export interface LoginResult {
  token: string;
  username: string;
  expirationDate?: string;
}

const isBlockedLogin = (data: Record<string, unknown>): boolean =>
  data.blocked === true
  || String(data.error ?? '').toLowerCase().includes('blocked');

const getErrorMessage = (data: Record<string, unknown>, fallback: string): string => {
  const message = typeof data.message === 'string' ? data.message : undefined;
  const error = typeof data.error === 'string' ? data.error : undefined;
  return message || error || fallback;
};

export const login = async (params: { username: string; password: string }): Promise<LoginResult> => {
  try {
    const response = await axios.post<LoginResult>(
      `${authBaseUrl()}/auth/login`,
      { email: params.username, password: params.password },
      {
        headers: { 'Content-Type': 'application/json' },
        timeout: 10000,
      }
    );
    return response.data;
  } catch (error: unknown) {
    const response = axios.isAxiosError(error) ? error.response : undefined;

    if (response) {
      const data = (response.data ?? {}) as Record<string, unknown>;

      if (response.status === 401 && isBlockedLogin(data)) {
        throw new ApiError(
          getLoginRateLimitMessage('se'),
          ERROR_TYPES.RATE_LIMITED,
          401,
          response,
        );
      }

      throw new ApiError(
        getErrorMessage(data, 'Invalid credentials'),
        ERROR_TYPES.GENERIC,
        response.status,
        response,
      );
    }

    throw error;
  }
};
